import { FC, useState, Fragment } from "react";
import { IconButton } from "@mui/material";
import { IconFileTypePdf } from '@tabler/icons-react';
import Container from "./Container";
import PDFContainer from "./PDFContainer"
import { BtnPDFType } from "./type";

const BtnPDF: FC<BtnPDFType> = ({ className, selectedKycId }) => {
    const [open, setOpen] = useState(false);

    return (
        <Fragment>
            <IconButton onClick={() => setOpen(true)}>
                <IconFileTypePdf className={className} />
            </IconButton>
            <Container open={open} setOpen={setOpen} >
                <PDFContainer selectedKycId={selectedKycId} setOpen={setOpen} />
            </Container>
        </Fragment>
    )
}

export default BtnPDF;


/* 
    Componente que sirve como contenedor general y define el estilo del call to action para descargar el reporte en PDF

    - Daniel Bonilla Septiembre 2025
*/